var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandwidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1701_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8418 24.5361L22.208 14.25L24.3942 15.178L20.4131 24.5568L17.8418 24.5361Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 27.3125C20.3117 27.3125 21.375 26.2492 21.375 24.9375C21.375 23.6258 20.3117 22.5625 19 22.5625C17.6883 22.5625 16.625 23.6258 16.625 24.9375C16.625 26.2492 17.6883 27.3125 19 27.3125Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0003 8.70801C10.9117 8.70801 4.35449 15.2652 4.35449 23.3538H1.97949C1.97949 13.9535 9.59998 6.33301 19.0003 6.33301C28.4007 6.33301 36.0212 13.9535 36.0212 23.3538H33.6462C33.6462 15.2652 27.089 8.70801 19.0003 8.70801Z",
    fill: "#B2D530"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1701_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandwidth);
export default __webpack_public_path__ + "static/media/bandwidth.96e815f4193881ae87e7e034acbb0f63.svg";
export { ForwardRef as ReactComponent };